import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { mainRouteInitial } from "../../Data/Constant";
import { useUserShopDetailsData } from "../../API_Master/GetAPI";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { handleViewVendorListDetails } from "../../Redux/Slices/ProjectSlice";
import { NIGHT_EYE_IMG_URL } from "../../Process";
import DailyCloseModel from "../../Components/DailyCloseModel";
import DirectionMap from "../DepartmentVendorLIst/DirectionMap";

const RegisterVendorList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userId = Cookies.get("VENDER_NIGHT_EYE_USER_ID") || "";

  const { data: shops = [], isLoading, refetch } = useUserShopDetailsData(null, userId);

  // ── Daily Close Modal States ───────────────────────────────────────
  const [showDailyCloseModal, setShowDailyCloseModal] = useState(false);
  const [selectedShopForClose, setSelectedShopForClose] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);

  const [directionData, setDirectionData] = useState(null);
  const [openMapModel, setOpenMapModel] = useState(false);

  const handleEditShopDetails = (shop) => {
    const isAllDetailsCompleted = shop.IsStep1 && shop.IsStep2 && shop.IsStep3;
    Cookies.set("IsStep1Completed", isAllDetailsCompleted ? false : shop.IsStep1);
    Cookies.set("IsStep2Completed", isAllDetailsCompleted ? false : shop.IsStep2);
    Cookies.set("IsStep3Completed", isAllDetailsCompleted ? false : shop.IsStep3);
    Cookies.set("NIGHT_EYE_SHOP_DETAIL_ID", shop?.ShopDetailID);
    navigate(`/${mainRouteInitial}/VendorRegistration`);
  };

  // ── Daily Close Handlers ───────────────────────────────────────────
  const handleOpenDailyClose = (shop) => {
    setSelectedShopForClose(shop);
    setShowDailyCloseModal(true);
  };
  const openModal = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };
  const handleRegisterNewVendor = () => {
    Cookies.set("IsStep1Completed", false);
    Cookies.set("IsStep2Completed", false);
    Cookies.set("IsStep3Completed", false);
    Cookies.remove("VENDER_NIGHT_EYE_USER_ID");
    navigate(`/${mainRouteInitial}/VendorRegistration`);
  };
  const handleAddMoreShop = () => {
    Cookies.set("IsStep1Completed", false);
    Cookies.set("IsStep2Completed", false);
    Cookies.set("IsStep3Completed", false);
    Cookies.remove("NIGHT_EYE_SHOP_DETAIL_ID");
    navigate(`/${mainRouteInitial}/VendorRegistration`);
  };

  const directionOnMap = (data) => {
    setDirectionData(data);
    setOpenMapModel(true);
  };

  // ── JSX ─────────────────────────────────────────────────────────────
  return (
    <div>
      <div className="flex flex-col flex-1 w-full mx-auto px-4 md:px-8 py-8 space-y-8">
        {/* Page Heading */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div className="flex flex-col gap-1">
            <h3 className="text-[#0d141b] dark:text-white text-3xl md:text-4xl font-black leading-tight tracking-[-0.033em]">Vendor Details</h3>
          </div>
          <div className="flex gap-2">
            <button
              onClick={() => handleRegisterNewVendor()}
              className="flex items-center gap-2 bg-red-600 hover:bg-red-600 text-white px-5 py-2.5 rounded-lg font-bold text-sm transition-all shadow-lg shadow-red-500/20"
            >
              <span className="material-symbols-outlined text-[20px]">add_business</span>
              Register New Vendor
            </button>
            {
              <button
                onClick={handleAddMoreShop}
                className="flex items-center gap-2 bg-primary hover:bg-blue-600 text-white px-5 py-2.5 rounded-lg font-bold text-sm transition-all shadow-lg shadow-blue-500/20"
              >
                <span className="material-symbols-outlined text-[20px]">add_business</span>
                Add More Shop
              </button>
            }
          </div>
        </div>
        <div className="flex flex-col bg-white dark:bg-[#1a2632] rounded-xl border border-[#e7edf3] dark:border-gray-700 shadow-sm ">
          {/* Table Header (desktop) */}
          <div className="hidden md:grid grid-cols-12 gap-4 px-6 py-3 bg-gray-50 dark:bg-[#1e2a36] border-b border-[#e7edf3] dark:border-gray-700 text-xs font-bold text-[#4c739a] uppercase tracking-wider">
            <div className="col-span-3">Shop Name & Type</div>
            <div className="col-span-2">Area / Zone</div>
            <div className="col-span-1">Status</div>
            <div className="col-span-1">Helpers</div>
            <div className="col-span-2">Timings</div>
            <div className="col-span-3">Actions</div>
          </div>

          {/* Rows */}
          {isLoading ? (
            <div className="p-10 text-center text-gray-500 dark:text-gray-400">Loading shops...</div>
          ) : shops.length === 0 ? (
            <div className="p-10 text-center text-gray-500 dark:text-gray-400">{shops.length === 0 ? "No shops registered yet" : "No shops match the selected filters"}</div>
          ) : (
            shops.map((shop) => {
              const imageUrl = shop.ShopImage ? `${NIGHT_EYE_IMG_URL}/SmartCollection/ShopImage/${shop.ShopImage}` : null;

              return (
                <div
                  key={shop.ShopDetailID}
                  className="group flex flex-col md:grid md:grid-cols-12 gap-4 p-4 md:px-6 md:py-5 border-b border-[#e7edf3] dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors items-center"
                >
                  {/* Shop Name & Type */}
                  <div className="col-span-3 flex items-center gap-4 w-full">
                    {imageUrl && (
                      <div className="flex justify-end">
                        <div
                          className="size-10 rounded-lg bg-slate-100 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 cursor-pointer overflow-hidden group relative"
                          onClick={() => openModal(imageUrl)}
                        >
                          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors flex items-center justify-center">
                            <span className="material-symbols-outlined text-white opacity-0 group-hover:opacity-100 text-xl">visibility</span>
                          </div>
                          <img
                            src={imageUrl}
                            alt="Shop close proof"
                            className="w-full h-full object-cover"
                            onError={(e) => {
                              e.target.src = "/fallback-proof-placeholder.jpg"; // optional fallback
                            }}
                          />
                        </div>
                      </div>
                    )}

                    <div className="flex flex-col">
                      <p className="text-[#0d141b] dark:text-white font-bold text-base">{shop.ShopName || "Unnamed Shop"}</p>
                      <p className="text-[#4c739a] dark:text-gray-400 text-xs">{shop.Type}</p>
                    </div>
                  </div>

                  {/* Area / Zone */}
                  <div className="col-span-2 w-full">
                    <p className="text-sm text-[#0d141b] dark:text-gray-200">{shop.AreaName || shop.CityName || "—"}</p>
                    <p className="text-xs text-[#4c739a] dark:text-gray-400">{shop.ZoneName || "—"}</p>
                  </div>

                  {/* Status */}
                  <div className="col-span-1 w-full flex md:block">
                    <div
                      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-bold ${
                        shop.ShopVerifiedStatus === "true"
                          ? "bg-emerald-50 dark:bg-emerald-900/30 border border-emerald-100 dark:border-emerald-800 text-emerald-700 dark:text-emerald-400"
                          : "bg-amber-50 dark:bg-amber-900/30 border border-amber-100 dark:border-amber-800 text-amber-700 dark:text-amber-400"
                      }`}
                    >
                      <span className={`size-1.5 rounded-full ${shop.ShopVerifiedStatus === "true" ? "bg-emerald-600" : "bg-amber-500"}`} />
                      {shop.ShopVerifiedStatus === "true" ? "Verified" : "Pending"}
                    </div>
                  </div>

                  {/* Helpers */}
                  <div className="col-span-1 w-full flex md:block">
                    <div className="flex items-center gap-2 text-sm text-[#0d141b] dark:text-gray-200">
                      <span className="material-symbols-outlined text-gray-400 text-[18px]">group</span>
                      {shop.ShopHelperDetail?.filter((h) => h.IsActive)?.length || 0}
                    </div>
                  </div>

                  {/* Timings */}
                  <div className="col-span-2 w-full">
                    <p className="text-sm text-[#0d141b] dark:text-gray-200">
                      {shop.ShopOpenTime} – {shop.ShopCloseTime}
                    </p>
                  </div>

                  {/* Actions */}
                  <div className="col-span-3 flex flex-wrap gap-2 w-full mt-2 md:mt-0">
                    <button
                      onClick={() => handleEditShopDetails(shop)}
                      className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold text-white bg-primary rounded-lg hover:bg-blue-600 shadow-sm shadow-blue-500/30 transition-colors"
                    >
                      <span className="material-symbols-outlined text-[16px]">visibility</span>
                      Edit
                    </button>
                    {/* <button
                    // onClick={() => handleOpenDailyClose(shop)}
                    className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold text-white bg-red-600 rounded-lg hover:bg-red-700 shadow-sm shadow-red-500/30 transition-colors"
                  >
                    <span className="material-symbols-outlined text-[16px]">cloud_upload</span>
                    Daily Close
                  </button> */}
                    {/* <div className="col-span-3 flex flex-wrap gap-2 w-full mt-2 md:mt-0"> */}
                    <button
                      onClick={() => directionOnMap(shop)}
                      className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold text-white bg-primary rounded-lg hover:bg-blue-600 shadow-sm shadow-blue-500/30 transition-colors"
                    >
                      <span className="material-symbols-outlined text-[16px]">map</span>
                      On Map
                    </button>
                    {openMapModel && (
                      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/10 directiondivMap">
                        <div className="bg-white rounded-lg w-[100%] max-w-5xl p-4 relative">
                          <button onClick={() => setOpenMapModel(false)} className="absolute top-2 right-2 text-gray-600 mapzindex">
                            ✕
                          </button>

                          <DirectionMap directionData={directionData} />
                        </div>
                      </div>
                    )}
                    {/* </div> */}
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>

      {/* =================== DAILY CLOSE MODAL =================== */}
      {/* =================== DAILY CLOSE MODAL =================== */}
      {/* =================== DAILY CLOSE MODAL =================== */}

      {selectedImage && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4" onClick={closeModal}>
          <div className="relative max-w-5xl max-h-[90vh] w-full h-full rounded-xl overflow-hidden shadow-2xl" onClick={(e) => e.stopPropagation()}>
            {/* Close button */}
            <button
              className="absolute top-4 right-4 z-10 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors"
              onClick={closeModal}
              aria-label="Close modal"
            >
              <span className="material-symbols-outlined">close</span>
            </button>

            {/* Image */}
            <img
              src={selectedImage}
              alt="Full size shop close proof"
              className="w-full h-full object-contain bg-slate-900"
              onError={(e) => {
                e.target.src = "/fallback-large-placeholder.jpg";
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default RegisterVendorList;
